import React, {ReactNode, useState, useEffect} from 'react';
import {uniqueId} from 'lodash';
import {Portal} from 'react-portal';

export const createSlot = () => {
  const id = uniqueId('slot-');
  const Placeholder = () => <div id={id} />;
  const Slot = ({children}: {children: ReactNode}) => {
    const [container, setContainer] = useState<HTMLElement | null>();
    useEffect(() => {
      setContainer(document.getElementById(id));
    }, []);
    return (
      <Portal node={container}>
        {children}
      </Portal>
    );
  };
  return Object.assign(Slot, {Placeholder});
};
